import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { useResizeDetector } from "react-resize-detector";

const ClickRatesLineChart = () => {
  const { ref: resizeRef, width } = useResizeDetector();

  const [range, setRange] = useState("weekly");
  const [isDark, setIsDark] = useState(false);

  /* ---------------- Detect Dark Mode ---------------- */
  useEffect(() => {
    const checkTheme = () => {
      setIsDark(document.documentElement.classList.contains("dark"));
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  /* ---------------- DATA ---------------- */

  const weeklyData = [
    ["Day", "Click Rate"],
    ["Mon", 4],
    ["Tue", 7],
    ["Wed", 6],
    ["Thu", 9],
    ["Fri", 12],
    ["Sat", 15],
    ["Sun", 10],
  ];

  const monthlyData = [
    ["Month", "Click Rate"],
    ["Jan", 5],
    ["Feb", 8],
    ["Mar", 10],
    ["Apr", 9],
    ["May", 14],
    ["Jun", 18],
    ["Jul", 22],
    ["Aug", 20],
    ["Sep", 17],
    ["Oct", 19],
    ["Nov", 23],
    ["Dec", 26],
  ];

  const data = range === "weekly" ? weeklyData : monthlyData;

  /* ---------------- OPTIONS ---------------- */

  const options = {
    backgroundColor: "transparent",
    chartArea: { width: "85%", height: "75%" },
    curveType: "function",
    lineWidth: 3,
    pointSize: 6,
    colors: ["#38bdf8"],

    legend: {
      position: "bottom",
      textStyle: {
        color: isDark ? "#cbd5f5" : "#475569",
        fontSize: 11,
        fontName: "Poppins",
      },
    },

    hAxis: {
      gridlines: {
        color: isDark ? "#334155" : "#e5e7eb",
      },
      textStyle: {
        color: isDark ? "#cbd5f5" : "#475569",
        fontSize: 10,
        fontName: "Poppins",
      },
    },

    vAxis: {
      minValue: 0,
      ticks: [0, 5, 10, 15, 20, 25, 30],
      gridlines: {
        color: isDark ? "#334155" : "#e5e7eb",
      },
      textStyle: {
        color: isDark ? "#cbd5f5" : "#475569",
        fontSize: 10,
        fontName: "Poppins",
      },
      minorGridlines: { color: "transparent" },
    },
  };

  return (
    <div
      ref={resizeRef}
      className="
        w-full
        h-[388px]
        p-4
        rounded-xl
        bg-white dark:bg-slate-800
        shadow
        border border-slate-200 dark:border-slate-700
      "
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-5">
        <h6 className="m-0 text-base font-medium text-slate-800 dark:text-slate-200">
          Click Rate Trend
        </h6>

        <select
          value={range}
          onChange={(e) => setRange(e.target.value)}
          className="
            text-xs px-2 py-1 rounded
            border border-slate-300 dark:border-slate-600
            bg-white dark:bg-slate-900
            text-slate-900 dark:text-slate-200
            focus:outline-none
          "
        >
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>
      </div>

      {/* Chart */}
      {width > 0 && (
        <Chart
          chartType="LineChart"
          height="310px"
          data={data}
          options={options}
          loader={
            <div className="text-sm text-slate-500 dark:text-slate-400">
              Loading Chart...
            </div>
          }
        />
      )}
    </div>
  );
};

export default ClickRatesLineChart;